import { Resolve, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Samples } from '@df/samples/samples';
import { Events } from '@df/core/service/event';

@Injectable({
    providedIn: 'root'
})
export class SamplesCheckoutSuccessResolver implements Resolve<Checkout.ISuccessData> {
    constructor(private router: Router, private samples: Samples, private events: Events) {}

    resolve(): Promise<Checkout.ISuccessData> {
        return new Promise<Checkout.ISuccessData>((resolve, reject) => {
            this.samples
                .loadCheckoutSuccess()
                .then(result => {
                    const successData = result?.success;
                    if (successData) {
                        resolve(successData);
                    } else if (result?.post_redirect || result?.external_redirect) {
                        // we do nothing, redirect in progress
                    } else {
                        reject();
                    }
                })
                .catch(() => {
                    this.events.broadcast(Checkout.EVENTS.SuccessLoadError);
                    this.router.navigate([this.samples.config.checkoutUrl]);
                    reject();
                });
        });
    }
}
